'use client'

import { getBreakpoints } from '@src/utils/breakpoints.util'

import { defaultTopNavProps } from './TopNav.defaults'
import { type TopNavProps } from './TopNav.props'
import { TopNavDesktop } from './TopNavDesktop'
import { TopNavMobile } from './TopNavMobile'

export const TopNav = (props: TopNavProps = defaultTopNavProps) => {
  const { isMobile, isTablet } = getBreakpoints()
  return isMobile || isTablet ? <TopNavMobile {...props} /> : <TopNavDesktop {...props} />
}
